"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HealthComponent = void 0;
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _startingLife = /*#__PURE__*/new WeakMap();
var _currentLife = /*#__PURE__*/new WeakMap();
var _isDead = /*#__PURE__*/new WeakMap();
class HealthComponent {
  constructor(life) {
    _classPrivateFieldInitSpec(this, _startingLife, void 0);
    _classPrivateFieldInitSpec(this, _currentLife, void 0);
    _classPrivateFieldInitSpec(this, _isDead, void 0);
    _classPrivateFieldSet(_startingLife, this, life);
    _classPrivateFieldSet(_currentLife, this, life);
    _classPrivateFieldSet(_isDead, this, false);
  }
  get life() {
    return _classPrivateFieldGet(_currentLife, this);
  }
  get isDead() {
    return _classPrivateFieldGet(_isDead, this);
  }
  reset() {
    _classPrivateFieldSet(_currentLife, this, _classPrivateFieldGet(_startingLife, this));
    _classPrivateFieldSet(_isDead, this, false);
  }
  hit() {
    if (_classPrivateFieldGet(_isDead, this)) {
      return;
    }
    _classPrivateFieldSet(_currentLife, this, _classPrivateFieldGet(_currentLife, this) - 1);
    if (_classPrivateFieldGet(_currentLife, this) <= 0) {
      _classPrivateFieldSet(_isDead, this, true);
    }
  }
  die() {
    _classPrivateFieldSet(_currentLife, this, 0);
    _classPrivateFieldSet(_isDead, this, true);
  }
}
exports.HealthComponent = HealthComponent;